<template>
 
  <div align="center">
    <v-icon color="primary" class="pa-5" size="100">sentiment_dissatisfied</v-icon>
    <h1 class="primary--text">{{ $t("utils:error.pathNotFound.title") }}</h1>

    <div class="grey--text text--darken-2">
      {{ $t("utils:error.pathNotFound.body-1") }}
      <br/>
      {{ $t("utils:error.pathNotFound.body-2") }}
    </div>
  </div>
 
</template>
 <script>
   
    export default {
     
    };        
    
</script>
